/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeFilter } from "@/utils/params";
import { AxiosInstance } from "axios";
import { instanceLoggedAPI } from "../axiosConfig";
export default class ChallengesAPIService {
  private axiosInstance: AxiosInstance;
  constructor() {
    this.axiosInstance = instanceLoggedAPI;
  }
  async getJobChallenges(id: string): Promise<unknown> {
    return this.axiosInstance.get(`/jobs/${id}/job_challenges`)
  }
  async sendChallengeToCandidate(
    id: string,
    jobCandidateId: string
  ): Promise<unknown> {
    return this.axiosInstance.post(
      `/jobs/${id}/job_candidates/${jobCandidateId}/job_candidate_challenges/send_challenge`
    );
  }
  async assignChallengeToJob(id: string, payload: any): Promise<unknown> {
    return this.axiosInstance.post(`/jobs/${id}/job_challenges`, payload);
  }
  async updateChallengeToJob(
    id: string,
    payload: any,
    challengeId: string
  ): Promise<unknown> {
    return this.axiosInstance.put(
      `/jobs/${id}/job_challenges/${challengeId}`,
      payload
    );
  }
  async resendChallengeToCandidate(id: string): Promise<unknown> {
    return this.axiosInstance.post(`/code_signal/${id}/resend`);
  }
  async updateChallengeStatus(
    id: string,
    jobCandidateId: string,
    jobChallengeId: string,
    payload: any
  ): Promise<unknown> {
    return this.axiosInstance.put(
      `/jobs/${id}/job_candidates/${jobCandidateId}/job_candidate_challenges/${jobChallengeId}`,
      payload
    );
  }
  // "/jobs/#{job.id}/job_candidates/#{job_candidate.id}/job_candidate_challenges/#{job_candidate_challenge.id}"
}
export const ChallengesAPI = new ChallengesAPIService();
